// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"ff62b7cd","903":"9514c752","922":"c9bf2391"}[chunkId] + ".chunk.js";
};